/* eslint-disable class-methods-use-this */
/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Channel recommendations by book service
 *
 * @file ChannelRecommenationsByBookService.js
 * @author Mohamed yasar arabath M
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';

export default class ChannelRecommenationsByBookService extends BaseService {
  constructor() {
    super(constants.CHANNEL_REMEDIATION_BY_BOOK_REQUESTED, 'channelRemediationByBookStatus');
  }

  /**
   * Trigger the study channel recommendations by book api call
   *
   * @returns
   */
  handleEvent(eventName, eventData = {}) {
    const {
      bookId,
      channelId,
      chapters
    } = eventData;

    const payload = {
      bookId,
      channelId,
      chapters
    };

    return this.getClient('studyChannel').post('/search/byBook/learn/bulk', payload);
  }

  /**
   * Handle study channel recommendations by book api response and setting ChannelRecommendationsByBook store
   *
   * @param {*} response
   */
  handleResponse(response) {
    const channelRemediationByBook = Framework.getStoreRegistry().getStore('channelRemediationByBook');
    channelRemediationByBook.setRemediationData(response.data);
  }

  /**
   * Error handling
   *
   * @param {*} error
   */
  handleError(error) {
    Framework.getEventManager().publish(constants.CHANNEL_REMEDIATION_BY_BOOK_FAILED, error);
  }
}
